import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { loadingAction } from 'store/globalState/global';
import ElementsHall from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.elementsHall,
    app: state.app,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showLoading: bindActionCreators(loadingAction, dispatch),
  };
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ElementsHall));



// WEBPACK FOOTER //
// ./src/components/ElementsHall/container/index.js